window.HarriEngageServiceAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.HarriEngageServer);

    self.checkBrandLevelActivation = cacheService.cache(function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/level_activation', 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    })[0];

});
